import { intersectionWithSet } from "lib/actions/util";
import { getFileExtensions } from "./utils";

// A ZIP file containing at most one file with one of the following
// extensions can be handled directly by the back end.
export const knownFileExtensions = new Set<string>([
    "e57",
    "ifc",
    "las",
    "laz",
    "pts"
]);
  
export const isSingleFile = (filenames: string[]) => {
    const exts = getFileExtensions(filenames);
    return intersectionWithSet(exts, knownFileExtensions).length == 1;
};
